// @flow
import React, { Component } from 'react';
import styled, { keyframes } from 'react-emotion';
import { colors } from '../assets/scripts/constants';

/**
 * Styles
 */

const skRotateplane = keyframes`
	0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)
  } 50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
  } 100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
`;

const Spinner = styled('div')`
  position: relative;
  top: 6.5%;
  left: 6.5%;
  width: 75px;
  height: 75px;
  opacity: ${({ opacity }) => opacity};
  background-color: ${colors.orange};
  animation: ${skRotateplane} 1.2s infinite ease-in-out;
  transition: opacity 1s ease-in;
`;

/**
 * Component: DoorSpinner
 *
 * Loading spinner for door.
 */
export default class DoorSpinner extends Component<{}, { opacity: number }> {
  state = {
    opacity: 0,
  };

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        opacity: 1,
      });
    }, 25);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  timeout /* : TimeoutID */;

  render() {
    const { opacity } = this.state;
    return <Spinner opacity={opacity} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorSpinner.js